import { createBasicSelector } from 'util/redux'
import {
  selectBridgedWidgets,
  selectWidgets,
  selectWidgetsBootstrapped,
  selectWidgetsWithChat,
  selectWidgetsWithLiveChat,
} from 'ducks/widgets/selectors'
import { selectFolders } from 'selectors/folders/selectFolders'
import { selectRulesTotal } from 'ducks/rules/selectors/selectRulesTotal'
import { selectCustomerRatingSettingsCountIfLoaded } from 'ducks/customerRatingSettings/selectors/selectCustomerRatingSettingsCountIfLoaded'
import {
  USAGE_INBOX_CANNED_REPLIES,
  USAGE_INBOX_CHANNELS,
  USAGE_INBOX_FOLDERS,
  USAGE_INBOX_MAILBOXES,
  USAGE_INBOX_RULES,
  USAGE_INBOX_SATISFACTIONS_RATINGS,
  USAGE_INBOX_WIDGETS,
  USAGE_KB_ARTICLES,
  USAGE_KB_KBS,
  USAGE_INBOX_TEAMS,
  USAGE_CHAT_CHANNELS,
  USAGE_LIVE_CHAT_CHANNELS,
  USAGE_SOCIAL_CHAT_CHANNELS,
} from 'ducks/billing/usageTypes'
import { selectCannedReplyTemplatesTotalCount } from 'ducks/cannedReplies/selectors/selectCannedReplyTemplatesTotalCount'
import { selectKnowledgeBaseTotalOrNull } from 'subapps/kb/selectors/knowledge_bases/selectKnowledgeBaseTotalOrNull'
import { selectNonDeletedArticlesCount } from 'subapps/kb/selectors/articles/selectNonDeletedArticlesCount'
import { selectMailboxIds } from 'selectors/mailboxes/selectMailboxIds'
import { selectDemoMailboxId } from 'selectors/mailboxes/selectDemoMailboxId'
import { selectInaccessibleMailboxesIds } from 'selectors/mailboxes/selectInaccessibleMailboxesIds'
import { selectGroups } from 'selectors/app/groups/selectGroups'
import { isDefined } from 'util/nullOrUndefinedChecks'
import { INBOX, KB } from '../../productTypes'

export const selectLocalUsage = createBasicSelector(
  selectWidgets,
  selectWidgetsBootstrapped,
  selectFolders,
  selectRulesTotal,
  selectCustomerRatingSettingsCountIfLoaded,
  selectKnowledgeBaseTotalOrNull,
  selectNonDeletedArticlesCount,
  selectCannedReplyTemplatesTotalCount,
  selectMailboxIds,
  selectInaccessibleMailboxesIds,
  selectWidgetsWithChat,
  selectGroups,
  selectDemoMailboxId,
  selectBridgedWidgets,
  selectWidgetsWithLiveChat,
  (
    widgets,
    isWidgetLoaded,
    folders,
    rulesCountIfLoaded,
    csatSettingsCountIfLoaded,
    kbCountIfLoaded,
    kbArticlesCount,
    cannedRepliesCountIfLoaded,
    mailboxIds,
    inaccessibleMailboxesIds,
    widgetsWithChat,
    teams,
    demoMailboxId,
    socialChatWidgets,
    liveChatWidgets
  ) => {
    const mailboxCount =
      (mailboxIds || []).length +
      (inaccessibleMailboxesIds || []).length -
      (demoMailboxId ? 1 : 0)
    const widgetsWithChatCount = (widgetsWithChat || []).length
    const widgetsWithSocialChatCount = (socialChatWidgets || []).length
    const widgetsWithLiveChatCount = (liveChatWidgets || []).length
    const foldersNonDefault = folders.filter(f => !f.default).length
    const csatSettingsEnabled = isDefined(csatSettingsCountIfLoaded)
      ? csatSettingsCountIfLoaded > 0
      : csatSettingsCountIfLoaded

    return {
      [KB]: {
        [USAGE_KB_KBS]: kbCountIfLoaded,
        // We can't use billing.usage.kb.articles state, because we need to include draft ones two
        [USAGE_KB_ARTICLES]: isDefined(kbCountIfLoaded)
          ? kbArticlesCount
          : null,
      },
      [INBOX]: {
        [USAGE_INBOX_CANNED_REPLIES]: cannedRepliesCountIfLoaded,
        [USAGE_INBOX_CHANNELS]: mailboxCount + widgetsWithChatCount,
        [USAGE_INBOX_MAILBOXES]: mailboxCount,
        [USAGE_CHAT_CHANNELS]: widgetsWithChatCount,
        [USAGE_LIVE_CHAT_CHANNELS]: widgetsWithLiveChatCount,
        [USAGE_SOCIAL_CHAT_CHANNELS]: widgetsWithSocialChatCount,
        [USAGE_INBOX_WIDGETS]: isWidgetLoaded ? widgets.length : null,
        [USAGE_INBOX_RULES]: rulesCountIfLoaded,
        [USAGE_INBOX_FOLDERS]: foldersNonDefault,
        [USAGE_INBOX_SATISFACTIONS_RATINGS]: csatSettingsEnabled,
        [USAGE_INBOX_TEAMS]: teams.length,
      },
    }
  }
)
